import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_RADIUS_SM} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        padding: '5px 12px',
        borderRadius: SV_RADIUS_SM,
        border: '1px solid',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        maxWidth: '400px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surfaceMuted,
            borderColor: SV_LIGHT.line,
            color: SV_LIGHT.text,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surfaceMuted,
            borderColor: SV_DARK.line,
            color: SV_DARK.text,
        },
        '& svg': {
            flexShrink: 0,
        }
    }
}
